/** Caps each plain-text message excerpt after HTML sanitisation in the business-case context slice. */
export const ASSISTANT_BUSINESS_CASE_EXCERPT_MAX_CHARACTERS = 2_000;
